/**
 * Browser-only shim: give dependencies that read `process.env` something to
 * read. It pre-dates this repo's git history; it is kept because removing it
 * is a runtime question no build can answer.
 *
 * ⚠ **Loaded from `main.ts`, not from `angular.json`'s `polyfills` array —
 * Story 78.1.** The application builder decides whether an app is zoneless by
 * looking at that array: any entry ending in `.ts`/`.js` is assumed to
 * possibly import zone.js, so it injects `zone.js/node` into the SERVER
 * polyfill bundle (`@angular/build/src/tools/esbuild/utils.js` —
 * `isZonelessApp`). This app is zoneless and `zone.js` is not installed, so
 * that injection failed the build outright. Importing this file first from
 * `main.ts` preserves the evaluation order — ES module imports evaluate in
 * source order, so it still runs before any dependency that needs it — while
 * leaving the polyfills array with no `.ts` entry.
 *
 * ⚠ The guard matters even though `main.server.ts` never imports this file:
 * the server has a REAL `process`, and clobbering it with `{ env: {} }` would
 * break Node. The guard makes "never evaluated on the server" a property of
 * the code rather than an assumption about the import graph.
 */
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  if (!w.process) {
    w.process = { env: {} };
  }
}
